#import "../fragments/email-fragment.graphql"

query GetEmailDetails($emailId: ID!) {
    email(emailId: $emailId) {
        ...Email
    }
}
